/**
 * Page size for loading the full course list used by the library course filter dropdown.
 * Expected scale is small (~20 courses today, unlikely to exceed a few hundred).
 */
export const COURSE_FILTER_PAGE_SIZE = 500;

/**
 * Page size for loading the full library list on the Studio home Libraries tab.
 * Matches the backend max page_size (1000).
 */
export const LIBRARY_LIST_PAGE_SIZE = 1000;
